import { Moment } from 'moment';

/**
 * MyDatePicker doesn't use a standard Date object.
 */
export interface MyDatePickerModel {
    date?: MyDatePickerDate;
    jsDate?: Date;
}

export interface MyDatePickerDate {
    year: number;
    month: number;
    day: number;
    hour: number;
    min: number;
}

export class DateConverter {
    static toServerString(date: MyDatePickerModel): string {
        if (!date) {
            return null;
        }

        return `${date.date.month}/${date.date.day}/${date.date.year}`;
    }

    static fromDateToServerString(date: Moment): string {
        if (!date) {
            return null;
        }

        var day = date.date() < 10 ? `0${date.date()}` : date.date().toString();
        var month = date.month() < 9 ? `0${date.month() + 1}` : (date.month() + 1).toString();

        return `${month}/${day}/${date.year()}`;
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/helpers/date.converter.ts